export default [
    "24 24",
    '<path d="M17 18H7M20 14H4M17 10H7M20 6H4" stroke="var(--ci-primary-color, currentColor)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
]

